import { Box, Typography } from "@mui/material";

const StatusTabs = ({ active, setActive }) => {
  const filters = ["All", "Active", "Inactive", "Under Threshold"];
  return (
    <Box sx={{ display: "flex" }}>
      {filters.map((filter, index) => {
        return (
          <Box
            key={index}
            sx={{
              padding: "9px 18px",
              borderRadius: "4px",
              backgroundColor: filter === active ? "#ECE9F1" : "#fff",
            }}
            onClick={() => setActive(filter)}
          >
            <Typography
              variant="body2"
              sx={{
                fontSize: "14px",
                lineHeight: "20px",
                fontWeight: 500,
                color: filter === active ? "#252525" : "#5D6679",
                cursor: "pointer",
              }}
            >
              {filter}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default StatusTabs;
